export default "__VITE_ASSET__Dr5q5DKz__"